var PREFIX = "CONSOLE.";
// ACTION TYPES
export var SET_CLEAR_CONSOLE_CALLBACK = PREFIX + "SET_CLEAR_CONSOLE_CALLBACK";
export var SET_PRINT_TO_CONSOLE_CALLBACK = PREFIX + "SET_PRINT_TO_CONSOLE_CALLBACK";
